<template>
  <el-card shadow="never" class="reporting-content">
    <el-row :gutter="20">
      <el-col :span="6">
        <ul>
          <li><span class="text">Barangay:</span><span class="value">{{ form.barangay }}</span></li>
        </ul>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="block-title">
          INFO
        </div>
        <ul>
          <li><span class="text">Registration Body:</span><span class="value">{{ registrationBodyName }}</span></li>
          <li><span class="text">Registration Date:</span><span class="value">{{form.registrationDate}}</span></li>
          <li v-if="form.registrationBody == 1"><span class="text">DTI No.:</span><span class="value">{{ form.dtiNo }}</span></li>
          <li v-if="form.registrationBody == 2"><span class="text">SEC No.:</span><span class="value">{{ form.secNo }}</span></li>
          <li v-if="form.registrationBody == 3"><span class="text">CDA No.:</span><span class="value">{{ form.cdaNo }}</span></li>
          <li><span class="text">Line of Business:</span><span class="value">{{ form.lineOfBusiness }}</span></li>
        </ul>

        <div v-if="files.phic">
          <div class="file-row">
            <span @click="viewFile(files.phic.url, files.phic, -1, false)" class="file-row__file-name">{{ files.phic.name }}</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="block-title">
          PHIC
        </div>
        <ul>
          <li><span class="text">Philippine Health Insurance Corporation (PHIC)#:</span><span class="value">{{ form.phicN }}</span></li>
          <li><span class="text">Name (Person Responsible for filing):</span><span class="value">{{form.phicName}}</span></li>
          <li><span class="text">Title/Position of Signatory:</span><span class="value">{{ form.phicTitle }}</span></li>
          <li><span class="text">TIN of Signatory:</span><span class="value">{{ form.phicTIN }}</span></li>
        </ul>
      </el-col>
      <el-col :span="6">
        <div class="block-title">
          SSS
        </div>
        <ul>
          <li><span class="text">Social Security System (SSS) #:</span><span class="value">{{ form.sssN }}</span></li>
          <li><span class="text">Name (Person Responsible for filing):</span><span class="value">{{form.sssName}}</span></li>
          <li><span class="text">Title/Position of Signatory:</span><span class="value">{{ form.sssTitle }}</span></li>
          <li><span class="text">TIN of Signatory:</span><span class="value">{{ form.sssTIN }}</span></li>
        </ul>
      </el-col>
      <el-col :span="6">
        <div class="block-title">
          HDMF
        </div>
        <ul>
          <li><span class="text">Home Development Mutual Fund (HDMF) #:</span><span class="value">{{ form.hdmfN }}</span></li>
          <li><span class="text">Name (Person Responsible for filing):</span><span class="value">{{ form.hdmfName }}</span></li>
          <li><span class="text">Title/Position of Signatory:</span><span class="value">{{ form.hdmfTitle }}</span></li>
          <li><span class="text">TIN of Signatory:</span><span class="value">{{ form.hdmfTIN }}</span></li>
        </ul>
      </el-col>
    </el-row>

    <div v-if="viewerType == 1">
      <sweet-modal v-if="viewerType == 1" ref="nestedChild">
        <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
      </sweet-modal>
    </div>
    <div v-if="viewerType == 2">
      <div v-show="false" class="images" v-viewer="getViewerSettings">
        <img :src="fileUrl" :key="fileUrl" />
      </div>
    </div>
    <div class="mod" v-if="viewerType == 3">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
        :kind="'video'"
        :controls="true"
        :src="fileUrl"
      >
      </Media>
    </div>
    <div class="mod" v-if="viewerType == 4">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
        :kind="'audio'"
        :controls="true"
        :src="fileUrl"
      >
      </Media>
    </div>
  </el-card>
</template>

<script>
import axios from "axios";
import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
import { viewEditFileMixin } from '../../../mixins/viewEditFileMixin'
import Media from '@dongido/vue-viaudio'

export default {
  name: "TaxationContent",
  mixins: [viewEditFileMixin],
  components: {
    Media,
    SweetModal
  },
  data() {
    return {
      form: {
        registrationBody: null,
        registrationDate: null,
        dtiNo: null,
        secNo: null,
        cdaNo: null,
        lineOfBusiness: null,

        barangay: null,

        // PHIC
        phicN: null,
        phicName: null,
        phicTitle: null,
        phicTIN: null,

        // SSS
        sssN: null,
        sssName: null,
        sssTitle: null,
        sssTIN: null,

        //HDMF
        hdmfN: null,
        hdmfName: null,
        hdmfTitle: null,
        hdmfTIN: null,
      },

      files: {
        phic: null,
        sss: null,
        hdmf: null
      },

      registrationBodyList: [
        {id: 1, name: 'Department of Trade & Industry (DTI)'},
        {id: 2, name: 'Securities and Exchange Commission (SEC)'},
        {id: 3, name: 'Cooperative Development Authority (CDA)'},
      ],
    }
  },
  computed: {
    registrationBodyName() {
      const registrationBody = this.registrationBodyList.find(val => val.id === this.form.registrationBody)
      return registrationBody ? registrationBody.name : null
    },
  },
  async mounted() {
    await this.getStatutory()
    await this.getFiles()
  },
  methods: {
    async getStatutory(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/companies/itemCompanyStaturyInfo?companyId=${this.$route.query.companyId}`)
        .then(response => {
          this.form.registrationBody = response.data.item.registrationBody
          this.form.registrationDate = response.data.item.registrationDate
          this.form.dtiNo = response.data.item.dtiNo
          this.form.secNo = response.data.item.secNo
          this.form.cdaNo = response.data.item.cdaNo
          this.form.lineOfBusiness = response.data.item.lineOfBusiness

          this.form.barangay = response.data.item.barangay
          // PHIC
          this.form.phicN = response.data.item.phicN
          this.form.phicName = response.data.item.phicName
          this.form.phicTitle = response.data.item.phicTitle
          this.form.phicTIN = response.data.item.phicTIN
          // SSS
          this.form.sssN = response.data.item.sssN
          this.form.sssName = response.data.item.sssName
          this.form.sssTitle = response.data.item.sssTitle
          this.form.sssTIN = response.data.item.sssTIN
          //HDMF
          this.form.hdmfN = response.data.item.hdmfN
          this.form.hdmfName = response.data.item.hdmfName
          this.form.hdmfTitle = response.data.item.hdmfTitle
          this.form.hdmfTIN = response.data.item.hdmfTIN
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    async getFiles() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      try {
        const { data } = await axios.post(`/api/v1/entityFiles/listOfArrTypeId?entityId=${this.$route.query.companyId}`, { entityTypeIdArr: [58, 59, 60] })

        data.list.forEach(val => {
          if (val.entityTypeId === 58) {
            this.files.phic = val
          }
          if (val.entityTypeId === 59) {
            this.files.sss = val
          }
          if (val.entityTypeId === 60) {
            this.files.hdmf = val
          }
        })
        console.log('list', data)
      } catch (err) {
        console.log(err)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.reporting-content {
  ul {
    margin-top: 20px;
    list-style: none;
    padding-left: 0;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
      .text {
        font-size: 18px;
        color: grey;
      }
      .value {
        margin-left: 10px;
      }
    }
  }
  .block-title {
    font-size: 18px;
    font-weight: bold;
  }
}
.file-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__file-name {

    // max-width: 220px;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    cursor: pointer;
    color: #409EFF;
  }
}
</style>
